// extracted by mini-css-extract-plugin
module.exports = {"construction":"Construction--construction--2-PCB","construction__col":"Construction--construction__col--2Wgzq"};